import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { CalendarScheduleIcon } from '@moia-dev/pace-icons'
import { useTranslation } from 'react-i18next'
import { VehiclePlansAreaRoutes } from './VehiclePlansAreaRoutes'

export const VehiclePlansAreaNavigation = ({
  onClick,
  open,
}: AreaNavigationProps) => {
  const { t } = useTranslation()
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={t('vehiclePlans_title')}
      to={VehiclePlansAreaRoutes.route}
      Icon={CalendarScheduleIcon}
    />
  )
}
